import React, { useState, useEffect, Fragment } from "react";
import {
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";
import { LoadingMessage } from "../../Controls";
import { WizzMode } from "../../types";
import { useEntities } from "../../Wizzard";
import style from "./../../styles.module.scss";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { DateField, truncateNumber } from "../../../../utils";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { showToast } from "../../../../utils/Helper";

const Portfolios = ({ mode, services, assetId, toggleOrder, assetInfo, opsViewAccountName }) => {
  const [, setReadonly] = useState(mode == WizzMode.View);
  const [] = useState({ open: false });
  const [] = useEntities({});
  const [portfolio, setPortfolio] = useState({});
  const [date, setDate] = useState(new Date().toLocaleDateString("en"));
  const [] = useState({
    io: { open: false },
    order: { open: false },
    custody: { open: false },
    sellAll: { open: false },
  });
  const [loading, setLoading] = useState(false);
  const [empty, setEmpty] = useState(true);
  const [decimalAmount, setDecimalAmount] = useState();

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
    services.fetchPortfolios({ id: assetId, date: date }).then((res) => {
      res.portfolio.forEach((p) => {
        p.PortfolioQuantity = truncateNumber(p.PortfolioQuantity, assetInfo.SubAssetClassDecimalPlaces);
      });
      setPortfolio({ portfolio: res.portfolio });
      if (res.portfolio.length != 0) setEmpty(false);
    });
    services.assetInformation({ assetId: assetId }).then((response) => {
      setDecimalAmount(response.info.SubAssetClassDecimalPlaces);
    });
  }, [mode]);

  const handleOrder = (name, item) => {
    var quantity;
    {
      name == "Sell" ? (quantity = item.PortfolioQuantity) : (quantity = "");
    }
    toggleOrder("order", {
      order: {
        CurrentAccount: {
          AccountId: item.accountId,
          AccountName: item.AccountName,
          AccountNumber: item.AccountNumber,
          Quantity: quantity,
        },
        AccountId: item.accountId,
        AccountName: item.AccountName,
        AccountNumber: item.AccountNumber,
        OrderSide: name,
        OrderQuantity: quantity,
        AssetId: assetId,
        AssetTicker: assetInfo.AssetTicker,
        AssetClassForm: assetInfo.AssetClassForm,
        AssetDescription: assetInfo.AssetDescription,
      },
    });
  };

  const changeDate = (value) => {
    setPortfolio({ portfolio: null });
    services
      .fetchPortfolios({ id: assetId, date: value })
      .then((res) => setPortfolio({ portfolio: res.portfolio }));
    setDate(value);
  };

  const handleDownload = () => {
    setLoading(true);
    services
      .AssetPortfoliosXLSX(portfolio)
      .then((r) => {
        if (r.response.count > 0) {
          try {
            const blob = new Blob([new Uint8Array(r.response.buffer.data)], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Portfolios.xlsx";
            link.click();
          } catch (ex) {}
        }
      })
      .catch((e) => {});
    setLoading(false);
  };

  return (
    <div>
      <Row>
        <Col>
          <FormGroup className={style.date}>
            <Label>Date</Label>
            <DateField
              label=""
              name="date"
              disabled={false}
              onChange={(name, value) => changeDate(value)}
              value={date}
            />
          </FormGroup>
        </Col>
        <Col style={{ textAlign: "right" }}>
          <LaddaButton
            className="btn btn-ladda btn-primary"
            data-style={EXPAND_RIGHT}
            disabled={empty}
            onClick={handleDownload}
            loading={loading}
          >
            <i className="fa fa-file-excel-o"></i>
          </LaddaButton>
        </Col>
      </Row>
      <Table>
        <thead>
          <tr>
            <th></th>
            <th>Number</th>
            {opsViewAccountName !== undefined ?
            (
              opsViewAccountName ?
              (
              <th>Account</th>
              )
              :
              (
                ""
              )
            )
            :
            <th>Account</th>
          }
            <th>Balance Type</th>
            <th className={style.alignRight}>Quantity</th>
            <th className={style.alignRight}>Average Price</th>
            <th className={style.alignRight}>Portfolio Invested</th>
          </tr>
        </thead>
        <tbody>
          {portfolio.portfolio ? (
            <Fragment>
              {portfolio.portfolio.map((item) => (
                <tr key={`sin-${item.DataProviderId}`}>
                  <td>
                    <UncontrolledDropdown>
                      <DropdownToggle className="brokerwarex-size" color="transparent" size="sm">
                        <i className="icon-options-vertical" style={{ color: "black" }}></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem name="Buy" onClick={(e) => handleOrder(e.target.name, item)}>
                          Buy
                        </DropdownItem>
                        <DropdownItem name="Sell" onClick={(e) => handleOrder(e.target.name, item)}>
                          Sell
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                  <td>{item.AccountNumber}</td>
                  {opsViewAccountName !== undefined ?
                  (
                    opsViewAccountName ?
                    (
                      <td>{item.AccountName}</td>
                    )
                    :
                    (
                      ""
                    )
                  )
                  :
                  <td>{item.AccountName}</td>
                  }
                  <td>{item.PortfolioBalanceType}</td>
                  <td className={style.alignRight}>
                    <FormattedNumber value={item.PortfolioQuantity} dataTypeDecimalName="quantity" />
                  </td>
                  <td className={style.alignRight}>
                    <FormattedNumber
                      value={item.PortfolioAveragePrice}
                      decimalScale={decimalAmount}
                      dataTypeDecimalName="price"
                    />
                  </td>
                  <td className={style.alignRight}>
                    <FormattedNumber value={item.PortfolioInvested} dataTypeDecimalName="currency" />
                  </td>
                </tr>
              ))}
              {portfolio.portfolio.length == 0 && <EmptyOrLoading />}
            </Fragment>
          ) : (
            <EmptyOrLoading loading={true} />
          )}
        </tbody>
      </Table>
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="12">
      {loading ? (
        <LoadingMessage text="Loading portfolios" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{ textAlign: "center" }}>
          No portfolios
        </span>
      )}
    </td>
  </tr>
);

export default Portfolios;
